import { useSelectableBusinessAreaQuery } from "../../common/hooks/useSelectableItemQueries.ts";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../localization/useTranslation.ts";

export interface BusinessAreaFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    businessAreas: Array<string> | undefined;
    isLoading: boolean;
    onChange: (businessAreas: Array<string>) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
    toolTipText?: string;
}

function BusinessAreaField(props: BusinessAreaFieldProps) {
    const { translateString } = useTranslation();
    let businessAreaQuery = useSelectableBusinessAreaQuery(!props.isPreview);

    return (
        <DotLegalMultiSelect
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            options={businessAreaQuery.data}
            isLoading={(businessAreaQuery.isLoading || props.isLoading) && !props.readOnly}
            chosenOptions={props?.businessAreas ?? []}
            onChange={props.readOnly ? () => {} : (value) => props.onChange(value)}
            label={translateString("businessAreas")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            toolTipText={props.toolTipText}
            errorText={props.errorText}
        />
    );
}

export default BusinessAreaField;
